import React, { useState } from "react";
import ReleasesList from "./ReleasesList";
import NewReleaseModal from "./NewReleaseModal";
import { useT } from "../../i18n";

const ReleasePage: React.FC = () => {
  const t = useT();
  const [searchQuery, setSearchQuery] = useState("");
  const [isNewReleaseModalOpen, setIsNewReleaseModalOpen] = useState(false);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="flex flex-col h-full">
      {/* Header - exact match from HTML */}
      <header className="flex items-center justify-between h-20 px-8 bg-white border-b border-gray-200">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            {t("releases.title")}
          </h2>
          <p className="text-sm text-gray-500">
            {t("releases.subtitle")}
          </p>
        </div>
        <div className="flex items-center space-x-4">
          <button
            onClick={() => setIsNewReleaseModalOpen(true)}
            data-testid="upload-release-btn"
            className="px-5 py-2.5 flex items-center bg-[#111827] text-white rounded-lg hover:bg-gray-800 transition-colors text-sm font-medium shadow-sm"
          >
            <i className="fa-solid fa-upload mr-2"></i> {t("releases.uploadRelease")}
          </button>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 p-8">
        {/* Releases List with integrated search and controls */}
        <ReleasesList searchQuery={searchQuery} onSearchChange={handleSearch} />

        {/* New Release Modal */}
        <NewReleaseModal
          isOpen={isNewReleaseModalOpen}
          onClose={() => setIsNewReleaseModalOpen(false)}
        />
      </main>
    </div>
  );
};

export default ReleasePage;
